import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

const AppearanceAnimation = ({ disabled, duration = '0.3s', children }) => {
  const [opacity, setOpacity] = useState(disabled ? 1 : 0)

  useEffect(() => {
    if (disabled) {
      return
    }
    const timer = window.setTimeout(() => setOpacity(1), 100)

    return () => {
      window.clearTimeout(timer)
    }
  }, [disabled, setOpacity])

  return (
    <Box
      sx={{
        opacity,
        transition: `opacity ${duration} ease`,
      }}
    >
      {children}
    </Box>
  )
}

AppearanceAnimation.propTypes = {
  disabled: PropTypes.bool,
  duration: PropTypes.string,
}

export default AppearanceAnimation
